module.exports = __webpack_public_path__ + "static/media/HealiaryTOS.639056b8.txt";